import { actionTypes } from '../constants';


export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_ASSET_OVERVIEW });
    };
};

export const previousSearchFilter = (searchParams) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.PREVIOUS_SEARCH_FILTER,
            searchParams
        });
    };
};

export const getAssetConditionIndicesRequest = (request) => ({
    type: actionTypes.LOAD_ASSET_CONDITION_INDICES_REQUEST,
    request
});

export const setSelectedAssetDetailsAction = (asset) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_SELECTED_ASSET_DETAILS, asset });
    };
};

export const setSelectedAssetAction = (data, assetList) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_SELECTED_ASSET, data: data && { ...data, id: data?.assetId } });
        if (assetList?.length > 0 && data) {
            const overviewAssetDetail = assetList?.find((asset) => asset?.id === data?.assetId || asset?.assetId === data?.assetId);
            // Fall back to the asset data from the overview list when the asset is not yet present
            dispatch(setSelectedAssetDetailsAction(overviewAssetDetail || { ...data, id: data?.assetId, name: data?.assetName || data?.name }));
        } else if (data) {
            // assetList is empty or unavailable – use the asset data directly so the right panel can open
            dispatch(setSelectedAssetDetailsAction({ ...data, id: data?.assetId, name: data?.assetName || data?.name }));
        }
    };
};

